import styled from 'styled-components';
import { ResponsiveLine } from '@nivo/line';
import { linearGradientDef } from '@nivo/core';
// import WeatherPartlySunny from '../../../icons/WeatherPartlySunny';

export const initialDayWidth = 80;
const initialDayHeight = 110;

const textColor = 'rgb(100, 100, 100)';
const DayText = styled.text`
    text-anchor: middle;
    font-family: sans-serif;
    /* font-size: 14px; */
    fill: ${textColor};
    ${({ $bold }) => $bold && `font-weight: 600`}
`;

const DayBlocks = ({ series, xScale, yScale, height, width, margin }) => {
    let { data, scaleFactor } = series[0];
    scaleFactor = scaleFactor || 1;
    const fontSize = 14 * scaleFactor;
    const textLineY = (lineNr) => 10 + (lineNr - 1) * (fontSize + 1);
    const dayWidth = initialDayWidth * scaleFactor;
    const dayHeight = initialDayHeight * scaleFactor;
    // const minX = Math.min(...data.map((d) => d.data.x));
    // const maxX = Math.max(...data.map((d) => d.data.x));
    return (
        <g>
            {data.map((d) => {
                return (
                    <g
                        key={d.data.x}
                        transform={`translate(${
                            xScale(d.data.x) - dayWidth / 2
                        },${height - dayHeight - margin.top})`}
                    >
                        <rect
                            x={0}
                            y={0}
                            width={dayWidth}
                            height={dayHeight}
                            fill="#FFF"
                        />
                        <DayText
                            x={dayWidth / 2}
                            y={textLineY(1)}
                            dy="1em"
                            fontSize={fontSize}
                            $bold
                        >
                            {d.data.x}
                        </DayText>
                        <DayText
                            x={dayWidth / 2}
                            y={textLineY(2)}
                            dy="1em"
                            fontSize={fontSize}
                        >
                            {Math.round(d.data.wind)} m/s
                        </DayText>
                        <DayText
                            x={dayWidth / 2}
                            y={textLineY(3)}
                            dy="1em"
                            fontSize={fontSize}
                        >
                            {Math.round(d.data.glob)} J/cm&sup2;
                        </DayText>
                        <image
                            href={`images/weather/${d.data.img}`}
                            width={50 * scaleFactor}
                            height={50 * scaleFactor}
                            y={textLineY(4) - 5 * scaleFactor}
                            x={(dayWidth - 50 * scaleFactor) / 2}
                        />
                    </g>
                );
            })}
        </g>
    );
};

const WeatherForecastLineChart = ({ data, scaleFactor = 1 }) => {
    const dayHeight = initialDayHeight * scaleFactor;
    const dayWidth = initialDayWidth * scaleFactor;

    const yMin = data.reduce((min, serie, i) => {
        const serieMin = serie.data.reduce((prevMin, d) => {
            if (d.y < prevMin) return d.y;
            else return prevMin;
        }, min);
        if (serieMin < min) return serieMin;
        else return min;
    }, Infinity);

    return (
        <ResponsiveLine
            data={data}
            colors={{ datum: 'color' }}
            theme={{
                dots: {
                    text: {
                        fill: textColor,
                    },
                },
            }}
            margin={{
                top: 20,
                right: dayWidth / 2 + 10,
                bottom: dayHeight,
                left: dayWidth / 2 + 10,
            }}
            xScale={{
                type: 'point',
            }}
            yScale={{
                type: 'linear',
                min: 'auto',
                max: 'auto',
                stacked: false,
                reverse: false,
            }}
            axisTop={null}
            axisRight={null}
            axisLeft={null}
            // axisBottom={{
            //     tickSize: 0,
            // }}
            axisBottom={null}
            pointSize={6}
            // pointColor={{ theme: 'background' }}
            // pointBorderWidth={2}
            // pointBorderColor={{ from: 'serieColor' }}
            pointLabelYOffset={-6}
            enablePointLabel
            pointLabel={(d) => `${Math.round(d.y)}°C`}
            curve="natural"
            enableArea
            enableGridX={false}
            enableGridY={false}
            useMesh={false}
            // tooltip={Tooltip}
            defs={[
                linearGradientDef('gradientA', [
                    { offset: 0, color: 'inherit' },
                    { offset: 100, color: 'inherit', opacity: 0 },
                ]),
            ]}
            fill={[{ match: '*', id: 'gradientA' }]}
            areaBaselineValue={yMin}
            layers={[
                DayBlocks,
                'grid',
                'markers',
                'axes',
                'areas',
                'crosshair',
                'lines',
                'points',
                'slices',
                'mesh',
                'legends',
            ]}
        />
    );
};

export default WeatherForecastLineChart;
